import { oldApi } from '@/api'
import { session } from '@/composables/useSession'
import type { Scorecard } from '@/modules/shared/TicketContent/types/scorecard'
import type { AutoQaCategoryType, RequireReasonVisibility, RootCause } from '@/types/category'
import type { ScaleType } from '@/data/scales'

interface Category {
  scorecards: Scorecard[]
  autoQaApplicabilities?: string[]
  autoQaCategory?: AutoQaCategoryType | null
  autoQaCustomCategoryTemplateId?: string
  conditions: { type: string; condition: any; values: string[] }[] | null
  created: string
  description: string
  dontCalcZero: boolean
  failCategory: boolean
  groupId?: number
  groupName?: string
  groupPosition?: number
  hideZero: boolean
  id: number
  isArchived: boolean
  isInactive: boolean
  name: string
  ownerId: number
  paymentId: number
  position: number
  ratingRangeMax: number
  ratingRangeMin: number
  requireReason: boolean
  multipleRequireReasons: boolean
  requireReasonVisibility: RequireReasonVisibility
  freeTextAllowed: boolean
  rootCauses: RootCause[]
  scale: ScaleType
  tags: string[]
  teamId: number
  updated: string
  weighting: number
  deletedAt: string | null
}

export const getCategories = (workspaceId: number) =>
  oldApi
    .get(`payments/${session.account.id}/teams/${workspaceId}/rating-categories`)
    .json<{ data: Category[]; total: number }>()
